import { Sequence } from "remotion";
import { FC } from "react";
import { cssStringToReactStyle } from "../../utils/cssStringToReactStyle";

interface Props {
  logo: string;
  logoStyle: string;
}

export const Logo: FC<Props> = ({ logo, logoStyle }) => {
  const parsedStyle = cssStringToReactStyle(logoStyle || "");

  const style: React.CSSProperties = {
    position: "absolute",
    ...parsedStyle, // Aplicamos lo que venga del string (posición)
    
    // --- AQUÍ FORZAMOS EL TAMAÑO ---
    width: "300px",  // <--- Cambia este número al tamaño que desees
    height: "auto",  // Mantiene la proporción
    zIndex: 999,     // Asegura que esté al frente
  };

  const StyledLogo: FC = () => {
    return <img src={logo} style={style} alt="Logo" />;
  };

  return <Sequence><StyledLogo /></Sequence>;
};
